import { createAction } from 'redux-actions';
// Handle the change event
export const mentionSearchChange = createAction(`MENTION.SEARCH_CHANGE`, ({ value , setMentions  })=>({
        value,
        setMentions
    }));
// Cache all users found on the page
export const initOnPageUsers = createAction(`MENTION.INIT_ON_PAGE_USERS`, (users)=>({
        users
    }));
// Store server friends list
export const populateFriends = createAction(`MENTION.POPULATE_FRIENDS`, (alpha, friends, page)=>({
        alpha,
        friends,
        page
    }));
